import NProgress from "nprogress";
import "nprogress/nprogress.css";

NProgress.configure({
  showSpinner: false,
  trickle: true,
  trickleSpeed: 220,
  minimum: 0.09,
  easing: "ease",
  speed: 420,
});

export { NProgress };
